export default {
  name: 'yıldız',
  title: 'Çokgen/Yıldız Aracı',
  buttons: [
    {
      title: 'Yıldız Aracı'
    },
    {
      title: 'Çokgen Aracı'
    }
  ],
  contextTools: [
    {
      title: 'Kenar Sayısı',
      label: 'noktalar'
    },
    {
      title: 'Sivrilik',
      label: 'Sivrilik'
    },
    {
      title: 'Yıldızı Kıvır',
      label: 'Döngüsel Kaydırma'
    },
    {
      title: 'Kenar Sayısı',
      label: 'kenarlar'
    }
  ]
}
